import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const BowlingColored = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g id="Bowling" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm4 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-3-4a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                    fill="#65697E"
                />
                <path
                    d="M12 21c-4.963 0-9-4.038-9-9s4.037-9 9-9c1.887 0 3.638.586 5.086 1.582a2.867 2.867 0 0 0-1.622.895 2.862 2.862 0 0 0-2.118-.945 2.885 2.885 0 0 0-2.882 2.882 2.88 2.88 0 0 0 2.425 2.836 2.845 2.845 0 0 0-.284 1.225 2.885 2.885 0 0 0 2.882 2.881 2.885 2.885 0 0 0 2.882-2.881c0-.442-.108-.855-.286-1.23a2.882 2.882 0 0 0 2.183-1.799A8.944 8.944 0 0 1 21 12c0 4.962-4.037 9-9 9m4.701-13.586c0-.486.396-.882.882-.882s.882.396.882.882a.883.883 0 0 1-.882.882.883.883 0 0 1-.882-.882m-1.214 3.179a.882.882 0 1 1 0 1.764.882.882 0 0 1 0-1.764m-2.141-2.297a.883.883 0 1 1 .002-1.766.883.883 0 0 1-.002 1.766M12 1C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1"
                    fill="#0D0E0F"
                />
            </g>
        </svg>
    );
};
